// hotel.js
const hotel = {
    edit_common_commodity: 'Edit common commodities',
    add_common_commodity: 'Add common commodities',
    tax_classification_code: 'Tax classification code',
    select_tax_classification_code: 'Please select the tax classification code',
    click_search: 'Click to search',
    specification_model: 'Specification model',
    enter_tax_specification_model: 'Please enter the tax specification model',
    unit_price: 'Unit price',
    enter_unit_price: 'Please enter the unit price',
    tax_rate: 'Tax rate',
    select_tax_rate: 'Please select the tax rate',
    tax_classification_name: 'Tax classification name',
    enter_tax_classification_name: 'Please enter the tax classification name',
    product_name: 'Product name',
    enter_product_name: 'Please enter the product name',
    metering_unit: 'Metering unit',
    enter_metering_unit: 'Please enter the metering unit',
    ticket_parameters_configuration: 'Ticket parameter configuration',
    child_extension_number: 'Extension number',
    is_open_full_electric_ticket: 'Whether to enable full electronic tickets',
    tips: 'Note: Please confirm whether full electronic invoices have been activated. If not, please select No.',
    invoice_parameters_configuration: 'Invoice parameter configuration - {value}',
    fill_parameters: 'Fill in parameters',
    invoice_type: 'Invoice method name',
    enterprise_basic_info: 'Enterprise basic information',
    enterprise_name: 'Enterprise name',
    enter_enterprise_name: 'Please enter the enterprise name',
    taxpayer_identification_number: 'Taxpayer identification number',
    tip_api_invoice: 'Note: This item is required if you need to issue invoices through the API.',
    enterprise_business_address: 'Enterprise business address',
    enterprise_phone: 'Enterprise phone number',
    enterprise_bank: 'Enterprise bank',
    enterprise_bank_account: 'Enterprise bank account number',
    taxpayer_category: 'Taxpayer category',
    small_scale_taxpayer: 'Small-scale taxpayer',
    general_taxpayer: 'General taxpayer',
    payee: 'Payee',
    reviewer: 'Reviewer',
    invoicer: 'Invoicer',
    invoice_collection_rules: 'Invoice collection rules',
    tip_invoice_collection: 'Note: Submitting invoice data will be verified according to the configuration rules to check if it is qualified.',
    restrict_invoice_title: 'Whether to restrict the invoice title to be consistent with the user unit',
    allow_vague_match: 'Whether to allow fuzzy matching between the invoice title and the user unit',
    tip_vague_match: 'After enabling, if the invoice title contains the user unit or the user unit contains the invoice title, the verification can pass.',
    invoice_title_blacklist: 'Invoice title blacklist',
    enter_invoice_title_blacklist: 'Please enter the invoice title blacklist',
    tip_blacklist_keywords: 'Separate multiple keywords with |, for example: Individual | Company | Limited',
    invoice_title_whitelist: 'Invoice title whitelist',
    enter_invoice_title_whitelist: 'Please enter the invoice title whitelist',
    tip_whitelist_keywords: 'Separate multiple keywords with |. If it is a multi - word phrase, connect them directly with +; for example: Hospital + Company | University + Company',
    tax_number_length_rule: 'Tax number length limit rule',
    digits: '{num} digits',
    invoice_info_collection_default: 'Default configuration for invoice information collection',
    tip_invoice_info_default: 'Note: This is the default configuration. When the project review selects this channel, the configuration will be synchronously applied to the project by default.',
    open_invoice_info_collection: 'Enable Invoice Information Collection?',
    optional_invoice_types: 'Optional invoice types',
    vat_electronic_invoice: 'VAT ordinary electronic invoice',
    vat_special_invoice: 'VAT special invoice',
    vat_paper_invoice: 'VAT ordinary paper invoice',
    fixed_amount_invoice: 'Fixed - amount invoice',
    fiscal_receipt: 'Fiscal receipt',
    required_invoice_info: 'Whether invoice information is required',
    allow_personal_invoice: 'Whether to allow personal invoices',
    collect_invoice_mailing_info: 'Whether to collect invoice mailing information',
    hotel_receipt_download: 'Download hotel fee receipt',
    hotel_receipt_template: 'Hotel fee receipt template',
    tip_receipt_template: 'It is recommended that the file size be less than 3M, and doc, docx formats are supported.',
    download_english_receipt_template: 'Download English receipt template',
    tag_info: 'Tag information',
    electronic_invoice_default: 'Default configuration for electronic invoices',
    tip_electronic_invoice_default: 'Note: This is the default configuration. When the project review selects this channel, the configuration will be synchronously applied to the project by default.',
    enable_electronic_invoice_management: 'Whether to enable electronic invoice management',
    disable_electronic_invoice: 'No, do not support issuing electronic invoices',
    enable_electronic_invoice: 'Yes, support online issuing of electronic invoices',
    hotel_personal_offline_invoice: 'Hotel personal [Offline payment] invoicing',
    not_allow_electronic_invoice: 'Do not allow application for electronic invoices',
    user_apply_admin_issue: 'Users can apply for [Admin to issue] electronic invoices',
    auto_issue_after_payment: 'Automatically issue invoices after user payment (only support electronic invoices)',
    hotel_personal_online_invoice: 'Hotel personal [Online payment] invoicing',
    hotel_team_offline_invoice: 'Hotel team [Offline payment] invoicing',
    hotel_team_online_invoice: 'Hotel team [Online payment] invoicing',
    invoice_remark_display: 'Invoice remark display format',
    custom_remark: 'Custom',
    fixed_remark: 'Fixed display',
    invoice_remark_info: 'Invoice remark information',
    enter_invoice_remark_info: 'Please enter the invoice remark information',
    tip_invoice_remark: 'Remarks on the invoice. If not filled in, the remarks on the invoice will be empty. If filled in, the remarks will be shown on the invoice as entered!',
    download_sample: 'Download sample',
    please_fill_in_complete_invoice_information: 'Please fill in the complete invoice information',
    service_item_configuration: 'Service item configuration - {name}',
    tax_simple_name: 'Tax classification abbreviation',
    goods_no: 'Enterprise commodity number',
    please_enter_content: 'Please enter the content to be queried',
    code: 'Code',
    concat_code: 'Combined code',
    goods_activity_name: 'Goods and labor name',
    add_tax_rate: 'VAT rate',
    add_tax_management: 'VAT special management',
    add_tax_by: 'VAT policy basis',
    summary: 'Summary',
    // Payment configuration related fields
    is_show_label: 'Whether to show on the cashier desk',
    is_show_desc: 'If you choose to hide this payment method, it will only be shown in the conference background, which means this payment method will not be shown during front - end payment.',
    pay_alias_label: 'Alias',
    pay_service_charge_label: 'Service charge ratio',
    pay_service_charge_desc:
        'Filling in the service charge rate means that the representative needs to bear the service charge. If not filled in, it defaults to 0, which means the representative does not need to bear the service charge (Decimal in half - width, for example, 3.3% is converted to 0.033).',
    is_refund_label: 'Whether to enable refund',
    partnerid_label: 'Partnerid (Cooperator id)',
    schoolcode_label: 'Schoolcode',
    accountid_label: 'Accountid',
    des_label: '3DES key',
    private_key_label: 'Merchant private key',
    public_key_label: 'Peking University cashier public key',
    pay_order_label: 'Sorting number',
    pay_order_rule: 'Sorting number for front - end display',
    pay_desc_label: 'Payment description',
    is_weixin_label: 'Whether to support WeChat payment',
    is_alipay_label: 'Whether to support Alipay payment',
    is_wechat_public_label: 'Whether to support WeChat official account payment',
    wechat_appid_label: 'APPID',
    wechat_appsecret_label: 'APPSecret',
    private_key_pfx_label: 'Private key certificate file',
    private_key_pfx_extra: 'Only .pfx format files can be uploaded. This private key is the merchant RSA private key certificate issued by Beijing CA to the merchant.',
    pfxpwd_label: 'Private key password',
    company_no: 'Merchant number',
    select_pfx: 'Please select a .pfx format file',
    merchant_id_label: 'Merchant Id',
    profile_id_label: 'Profile ID',
    access_key_label: 'Access key',
    secret_label: 'Secret key',
    api_key_id_label: 'apiKeyID',
    secret_key_label: 'Shared secret key',
    async_return_url_label: 'Asynchronous push address',
    view_example: 'View example',
    see_config_instructions: 'Account background payment configuration -> Secure Acceptance settings -> New Profile -> More columns in the Profile list -> View Profile -> Security -> View secret key',
    see_secret_key_instructions: 'Account background payment configuration -> Secret key management -> Generate secret key -> Check REST - Shared private key -> Generate secret key',
    gateway_public_key_label: 'ICBC gateway public key',
    corp_id_label: 'Enterprise number',
    aes_key_label: 'AESKEY',
    sby_public_key_label: 'Saibo Cloud gateway public key',
    mer_id_label: 'Merchant offline profile number / Merchant number',
    store_code_label: 'E - life profile number / Merchant agreement number',
    is_new_version_label: 'Whether it is a new - version interface',
    // ICBC aggregated payment configuration related fields
    agree_code_label: 'Cooperator agreement number',
    pay_type_label: 'Payment method',
    pay_type_desc: 'Please confirm the payment method with the bank staff. The interfaces are different.',
    pay_type_guarantee: 'Guaranteed payment',
    pay_type_direct: 'Direct payment',
    mall_code_label: 'Payee merchant number',
    mall_name_label: 'Merchant name',
    payee_company_name_label: 'Payee company name',
    payee_accno_label: 'Payee account number',
    params_set: 'Parameter configuration - {name}',
    // China Construction Bank payment configuration related fields
    bussiness_code_label: 'Merchant code',
    fenhang_code_label: 'Branch code',
    bussiness_gui_code_label: 'Merchant counter number',
    public_key_label: 'Public key',
    // Offline payment configuration related fields
    is_voucher_label: 'Whether to upload the remittance voucher',
    is_voucher_need: 'Required',
    is_voucher_not_need: 'Not required',
    is_voucher_must_label: 'Whether the remittance voucher must be uploaded',
    // Payment configuration list related fields
    online_payment: 'Online payment',
    offline_payment: 'Offline payment',
    payment_method_name: 'Payment method name',
    application_description: 'Application description',
    status: 'Status',
    fill_parameters: 'Fill in parameters',
    // Payment time configuration related fields
    edit_payment_time: 'Edit payment time',
    start_time_label: 'Start time',
    end_time_label: 'End time',
    // PayPal payment configuration related fields
    client_id_label: 'Client ID',
    secret: 'Secret',
    // Tsinghua University payment configuration related fields
    cooper_id_label: 'Cooperator number',
    key_label: 'Key',
    waibi_pay_num_label: 'Payment item number (Foreign currency)',
    zhifubao_pay_num_label: 'Payment item number (Alipay)',
    weixin_pay_num_label: 'Payment item number (WeChat)',
    // Stripe payment configuration related fields
    public_key_pk_label: 'Public key PK',
    private_key_sk_label: 'Secret key SK',
    async_push_address_label: 'Asynchronous push address',
    each_merchant_customized: 'Each merchant needs to be customized separately',
    // ShouXinYi payment configuration related fields
    sxy_merchant_number_label: 'ShouXin merchant number',
    encryption_method_label: 'Encryption method',
    sxy_payment_key_label: 'ShouXin payment key',
    asynchronous_return_address_label: 'Asynchronous return address',
    sxy_async_return_tip:
        'Please fill in the asynchronous return address in the "Customer service" - "Merchant information maintenance" - "Order background receiving address" on the ShouXinYi payment management background. Please notify the ShouXinYi customer service staff to add the server IP of the Meidikang server that actively queries the order results to the whitelist.',
    server_ip_label: 'Server IP:',
    server_ip_value: '255.255.255.255',
    async_push_type_label: 'And set the asynchronous push result push method to:',
    async_push_type_value: 'Single - item push',
    push_encoding_label: 'Push encoding is:',
    push_encoding_value: 'UTF - 8',
    special_attention_label: 'Special attention',
    attention: 'Note',
    async_return_address_warning: 'Please carefully check the asynchronous return address to ensure that it is filled in correctly!',
    apply_authorization_letter: 'Apply for authorization letter',
    // Allianz payment configuration related fields
    alliance_public_key_label: 'Allianz public key',
    // WeChat payment configuration related fields
    wechat_public_account_id_label: 'Public account ID',
    wechat_merchant_api_key_label: 'Merchant platform Api key',
    wechat_mp_verify_file_label: 'MP_verify_*.txt file',
    wechat_help_document_label: 'Help document',
    wechat_config_document_link_text: '《WeChat payment configuration instructions》',
    login: 'Login',
    wechat_platform: 'WeChat public platform',
    progress_1: '"WeChat payment" - "Merchant number management" - "Associated merchant numbers" - "Merchant number"',
    progress_2: '"Development" - "Basic configuration" - "Official account development information" - "Developer ID (AppID)"',
    progress_3: '"Development" - "Basic configuration" - "Official account development information" - "Developer password (AppSecret)"',
    progress_4: '"Account center" - "API security" - "API secret key" to find and set',
    // Xi'an Bank payment configuration related fields
    merchant_number_label: 'Merchant number',
    channel_number_label: 'Channel number',
    private_key_certificate_file_label: 'Private key certificate file',
    private_key_certificate_extra: 'Only .pfx format files can be uploaded, and the file size cannot exceed 500KB',
    password_label: 'Password',
    upload_credential_button_text: 'Upload credential',
    view_label: 'View',
    pay_order_rule_hint: 'Sorting number for front - end display',
    // ShouXinYi payment configuration related fields
    terminal_number_label: 'Terminal number',
    private_key_password_label: 'Private key password',
    wechat_payment_support_label: 'Whether to support WeChat payment',
    alipay_support_label: 'Whether to support Alipay payment',
    wechat_public_payment_support_label: 'Whether to support WeChat official account payment',
    sxy_backend_upload_process_link_text: 'ShouXinYi certificate merchant background upload process',
    sxy_certificate_download_process_link_text: 'ShouXinYi certificate download process',
    apply_authorization_letter_label: 'Apply for authorization letter',
    // School payment configuration related fields
    school_payment_merchant_number_label: 'School payment merchant number',
    merchant_private_key_label: 'Merchant private key',
    school_payment_public_key_label: 'School payment public key',
    private_key_version_label: 'Vendor private key version',
    // New Yinzhifutong configuration related fields
    sysid_label: 'sysId (Business system ID number)',
    itemid_label: 'itemId (Project classification ID)',
    system_certificate_label: 'System certificate',
    // YeePay configuration related fields
    interface_type_label: 'Interface type',
    instant_payment_interface_text: 'Instant payment interface',
    alipay_mobile_website_payment_tips: 'Note: If you need to use it on the micro - website, please activate the Alipay mobile website payment interface.',
    initiator_merchant_number_label: '*Initiator merchant number',
    merchant_number_label: '*Merchant number',
    app_key_label: '*appKey',
    merchant_application_private_key_label: '*Merchant application private key',
    // UnionPay QuickPass configuration related fields
    unionpay_appid_label: 'UnionPay AppId',
    unionpay_appkey_label: 'UnionPay appKey',
    source_code_label: 'Source code',
    unionpay_merchant_number_scan_label: 'UnionPay merchant number (Scan - code payment)',
    terminal_number_scan_label: 'Terminal number (Scan - code payment)',
    attachment_label: 'Attachment',
    medical_payment_application_form: 'Medical payment application form',
    project_number_label: 'Project number',
    meeting_id_label: 'Meeting ID',
    belonging_organization_label: 'Affiliated organization',
    partner_id_label: '*Cooperator ID',
    alipay_public_key_label: 'Alipay public key',
    this_public_key_is: 'This public key is',
    merchant_application_private_key_label: '*Merchant application private key',
    get_merchant_application_private_key: 'How to obtain the merchant application private key',
    business_help_center: 'Merchant help center',
    error_code_illegal_partner_exterface: 'Error code ILLEGAL_PARTNER_EXTERFACE',
    alipay_configuration_manual: '《Alipay configuration instructions》',
    authorization_letter: 'Authorization letter',
    common_problems: 'Common problems',
    please_visit: 'Please visit',
    search_error_code: 'Search for error code',
    agricultural_bank_root_certificate_file: 'Agricultural Bank root certificate file',
    file_suffix_truststore: 'File suffix is .truststore',
    merchant_certificate_directory_name: 'Merchant certificate storage directory file name',
    file_suffix_pfx: 'File suffix is .pfx',
    merchant_private_key_encryption_password: 'Merchant private key encryption password',
    business_number_label: 'Business number',
    password_label: 'Password',
    only_pem: 'Only .pem format files can be uploaded, and the file size cannot exceed 500KB',
    basic_info: 'Basic information',
    chinese: 'Chinese',
    english: 'English',
    hotel_name_cn: 'Hotel Chinese name',
    hotel_address_cn: 'Hotel Chinese address',
    hotel_distance_cn: 'Distance from the venue (Chinese)',
    hotel_introduce_cn: 'Hotel Chinese introduction',
    hotel_name_en: 'Hotel English name',
    hotel_address_en: 'Hotel English address',
    hotel_distance_en: 'Distance from the venue (English)',
    hotel_introduce_en: 'Hotel English introduction',
    basic_settings: 'Basic settings',
    is_open_booking: 'Whether to open reservations',
    hotel_open_object: 'Hotel open object',
    domestic_guests: 'Domestic guests',
    foreign_guests: 'Foreign guests',
    both_domestic_and_foreign_guests: 'Both domestic and foreign guests',
    only_for_vip: 'Whether to only open for VIPs',
    hotel_star: 'Hotel star rating',
    unknown: 'Unknown',
    three_star_approximate: 'Approximate three - star',
    three_star: 'Three - star',
    four_star_approximate: 'Approximate four - star',
    four_star: 'Four - star',
    five_star_approximate: 'Approximate five - star',
    five_star: 'Five - star',
    business: 'Business',
    checkin_start_date: 'Check - in start date',
    checkin_end_date: 'Check - in end date',
    checkout_start_date: 'Check - out start date',
    checkout_end_date: 'Check - out end date',
    hotel_image: 'Hotel image',
    image_size_hint: 'Size is 500x330, width - to - height ratio is 3:2',
    hotel_facilities: 'Hotel facilities',
    free_wifi: 'Free Wi - Fi',
    free_cable: 'Free cable',
    parking_lot: 'Parking lot',
    restaurant: 'Restaurant',
    swimming_pool: 'Swimming pool',
    gym: 'Gym',
    breakfast_included: 'Breakfast included',
    conference_shuttle_bus: 'Conference shuttle bus',
    new_hotel: 'Add new hotel',
    edit_hotel: 'Edit hotel',
    passenger_info: 'Guest information',
    name: 'Name',
    sex: 'Gender',
    mobile: 'Mobile phone number',
    hotel_name: 'Hotel name',
    room_type: 'Room type name',
    check_in_date: 'Check - in date',
    check_out_date: 'Check - out date',
    checkin_period: 'Check - in period',
    checkout_period: 'Check - out period',
    bed_room_bool: 'Book the whole room or bed',
    room_type_cn: 'Room type Chinese name',
    min_day: 'Minimum number of booking days',
    sort_num: 'Room type sorting',
    room_type_en: 'Room type English name',
    bed_nums: 'Number of beds in each room',
    deposit_mode: 'Deposit mode',
    enable_deposit_mode: 'Enable deposit mode',
    price_set_type: 'Price and quantity configuration method',
    batch_config: 'Batch configuration',
    individual_config: 'Individual configuration',
    price_quantity_setting: 'Quantity and price setting',
    date: 'Date',
    room_num: 'Number of rooms',
    cn_price: 'Domestic guest price',
    en_price: 'Foreign guest price',
    room_price: 'Room price',
    bed_price: 'Bed unit price',
    room_introduce: 'Room type introduction',
    submit_now: 'Submit now',
    both: 'Both whole - room and bed can be booked',
    only_room: 'Only whole - room can be booked',
    only_bed: 'Only bed can be booked',
    select_currency_cn: 'Please select the currency for domestic guests',
    chinese_yuan: 'Chinese Yuan',
    us_dollar: 'US Dollar',
    euro: 'Euro',
    hk_dollar: 'Hong Kong Dollar',
    mo_dollar: 'Macau Dollar',
    select_currency_en: 'Please select the currency for foreign guests',
    remaining_bed_count: 'Remaining number of beds',
    remaining_room_count: 'Remaining number of whole rooms',
    enter_room_price_cn: 'Please enter the whole - room price for domestic guests',
    enter_bed_price_cn: 'Please enter the bed price for domestic guests',
    enter_room_price_en: 'Please enter the whole - room unit price for foreign guests',
    enter_bed_price_en: 'Please enter the bed unit price for foreign guests',
    new_room_type: 'Add new room type',
    edit_room_type: 'Edit room type',
    tab_chinese_config: 'Domestic guest configuration',
    tab_foreign_config: 'Foreign guest configuration',
    tab_batch_operation: 'Batch operation',
    is_open_hotel_booking: 'Whether to enable hotel reservations',
    hotel_booking_restrictions: 'Hotel reservation restrictions',
    hotel_booking_deadline: 'Hotel reservation deadline',
    per_person_booking_limit: 'Per - person single - booking limit',
    can_book_multiple_times: 'Whether to allow multiple bookings',
    show_room_remaining_quantity: 'Whether to show the remaining room number',
    room_deduction_mode: 'Room quantity deduction method',
    collect_other_needs: 'Whether to collect other needs',
    booking_page_description: 'Reservation page description text',
    unrestricted: 'Unrestricted',
    need_ticket_selected: 'Need to select a ticket',
    need_ticket_and_paid: 'Need to select a ticket and pay successfully',
    can_book_multiple_times_yes: 'Can book multiple times',
    can_book_multiple_times_no: 'Can only pay for one order',
    show_room_surplus_no: 'Do not show',
    show_room_surplus_yes: 'Show',
    deduct_on_booking: 'Deduct after booking',
    deduct_after_payment: 'Deduct after successful payment',
    collect_other_needs_no: 'Do not collect',
    collect_other_needs_yes: 'Collect',
    room_type_statistics: 'Room type statistics',
    check_in_out_statistics: 'Check - in / check - out date statistics',
    room_shape: 'Room type',
    every_room_bed_count: 'Number of beds in each room',
    check_in_num: 'Number of check - ins',
    check_out_num: 'Number of check - outs',
    invoice_cn: 'Domestic guest invoice configuration',
    invoice_en: 'Foreign guest invoice configuration',
    invoice_params: 'Invoice parameter configuration',
    service: 'Service item',
    invoice_api: 'Invoice API configuration',
    channel_category_name: 'Channel category name',
    book_type: 'Reservation type',
    one_room: 'Whole room',
    onr_bed: 'Bed',
    order_info: 'Reservation information',
    pay_params: 'Payment parameter configuration',
    pay_time: 'Payment time configuration',
    is_show_refund_button: 'Whether to show the refund button',
    collect_refund_account_info: 'Whether to collect refund account information',
    booked: 'Booked',
    remaining: 'Remaining',
    // Hotel type page related
    add_hotel: 'Add hotel',
    vip_tag: 'VIP',
    open_status: 'Open',
    closed_status: 'Closed',
    open_object: 'Open object',
    domestic_guests: 'Domestic guests',
    foreign_guests: 'Foreign guests',
    both_domestic_and_foreign_guests: 'Domestic + Foreign guests',
    checkin_period: 'Check - in period',
    checkout_period: 'Check - out period',
    add_room_type: 'Add room type',
    deposit_mode_label: 'Deposit',
    confirm_delete_hotel: 'Are you sure you want to delete this hotel?',
    confirm_delete_room: 'Are you sure you want to delete this room type?',
    booking_content: 'Reservation content',
    certificate: 'Certificate',
    refund_deadline: 'Refund deadline',
    // Select day modal
    surplus: 'Remaining',
    check_in: 'Check - in',
    check_out: 'Check - out',
    select_date: 'Select date',
    check_in_out_date_required: 'Please select the start and end dates',
    select_check_out_date_required: 'Please select the check - out date',
    please_select_check_in_out_date: 'Please select the check - in and check - out dates',
    no_room_available_on_this_date: 'There are no available rooms on this date',
    min_day_required: 'The minimum number of check - in days is {minDay} days. You cannot select this date as the check - out date.',
    select_date_not_available: 'There are non - bookable dates within the selected date range. Please select again.',
    checkin_date_not_available: 'The check - in date must be between {checkin_start} and {checkin_end}.',
    checkout_date_not_available: 'The check - out date must be between {checkout_start} and {checkout_end}.',
    hotel_room_select: 'Hotel room type selection',
    price_start: 'Starting from',
    distance_from_the_venue: 'Distance from the venue',
    select_room: 'Select room type',
    select_room_required: 'Please select a room type',
    bed_name: 'Bed',
    room_name: 'Whole room',
    description: 'Description',
    check_in_out_date_name: 'Start - end date',
    check_in_out_date_required: 'Please select the start and end dates',
    check_in_date: 'Check - in time',
    check_out_date: 'Check - out time',
    book_num: 'Reservation quantity',
    select_book_num: 'Please select the reservation quantity',
    bed_tag: 'Bed',
    room_tag: 'Room',
    room_surplus: 'Remaining: ',
    hotel_config: 'Hotel facilities: ',
    book_text: 'Book now',
    room_treatment: 'Room type required treatment',
    please_select_room_treatment: 'Please select the room type required treatment'
};

export default hotel;
